const mapping = {
    up: {
        endDisplayValue: 'none',
        // eslint-disable-next-line max-len
        calculateProperty: (easeFunction) => (propertyValue, elapsedPart) => propertyValue - propertyValue * easeFunction(elapsedPart),
    },
    down: {
        endDisplayValue: 'block',
        // eslint-disable-next-line max-len
        calculateProperty: (easeFunction) => (propertyValue, elapsedPart) => propertyValue * easeFunction(elapsedPart),
    },
};

// eslint-disable-next-line no-underscore-dangle
const _slide = (direction, resolve, reject, element, duration = 300, easeFunction = (x) => x) => {
    if (!(element instanceof HTMLElement)) {
        reject('Variable "element" must be instance of HTMLElement');
        return;
    }
    if (typeof duration !== 'number') {
        // eslint-disable-next-line no-param-reassign
        duration = 300;
    }
    if (duration === 0) {
        element.style.display = mapping[direction].endDisplayValue;
        resolve();
        return;
    }
    if (getComputedStyle(element).display === mapping[direction].endDisplayValue) {
        resolve();
        return;
    }

    if (direction === 'down') {
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.display = 'block';
    }
    const animationProperties = ['height', 'marginTop', 'marginBottom', 'paddingTop', 'paddingBottom', 'borderWidth'];
    const computedStyle = getComputedStyle(element);
    const animationStyle = animationProperties.reduce((style, paramName) => {
        style[paramName] = Number.parseInt(computedStyle[paramName], 10);
        return style;
    }, {});
    if (direction === 'down') {
        element.style.display = 'none';
        element.style.position = '';
        element.style.visibility = '';
    }

    element.style.overflow = 'hidden';

    let start = null;
    const calculateProperty = mapping[direction].calculateProperty(easeFunction);

    const animationStep = (timestamp) => {
        if (start === null) start = timestamp;
        const elapsedTime = timestamp - start;
        let elapsedPart = elapsedTime / duration;
        if (elapsedPart > 1) elapsedPart = 1;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const prop in animationStyle) {
            element.style[prop] = `${calculateProperty(animationStyle[prop], elapsedPart)}px`;
        }
        if (direction === 'down' && element.style.display !== 'block') {
            element.style.display = 'block';
        }
        if (elapsedTime < duration) {
            requestAnimationFrame(animationStep);
            return;
        }
        element.style.display = mapping[direction].endDisplayValue;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const prop in animationStyle) {
            element.style[prop] = '';
        }
        element.style.overflow = '';
        resolve();
    };
    requestAnimationFrame(animationStep);
};

/*
ease param - easing function from GSAP
*/
const slideUp = async (element, duration, ease) => new Promise((resolve, reject) => {
    _slide('up', resolve, reject, element, duration, ease);
});

const slideDown = async (element, duration, ease) => new Promise((resolve, reject) => {
    _slide('down', resolve, reject, element, duration, ease);
});

// eslint-disable-next-line no-async-promise-executor
const slideToggle = (element, duration, ease) => new Promise(async (resolve) => {
    if (getComputedStyle(element).display === 'none') {
        await slideDown(element, duration, ease);
    } else {
        await slideUp(element, duration, ease);
    }
    resolve();
});

export {
    slideUp,
    slideDown,
    slideToggle,
};
